import { ReactNode, Suspense } from 'react';

interface I18nBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Ensures i18n is initialized before rendering children.
 * Uses React Suspense to handle loading states for translation resources.
 */
export function I18nBoundary({ children, fallback }: I18nBoundaryProps) {
  const defaultFallback = fallback ?? (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-600">Initializing...</p>
      </div>
    </div>
  );

  return <Suspense fallback={defaultFallback}>{children}</Suspense>;
}
